import { useFormikContext } from 'formik';
import { Col, Row } from 'react-bootstrap';
import AutocompleteV2 from 'src/app/modules/component/AutocompleteObjectV2';
import LabelRequired from 'src/app/modules/component/LabelRequired';
import { CODE_GENERATE_FORM, DEFAULT_PAGE_INDEX } from 'src/app/modules/utils/Constant';
import { getHospitalCategory } from 'src/app/modules/utils/ServicesUtils';

const BenhVienChuyenTuyen = () => {
    const { values, setFieldValue, errors, touched } = useFormikContext<any>();

    return (
        <>
            <Row className="align-items-center mt-3">
                <Col>
                    <LabelRequired label="Bệnh viện" className="min-w-125px" />
                    <AutocompleteV2
                        options={[]}
                        name="htHospital"
                        value={values?.[CODE_GENERATE_FORM.xuTriThongTinChuyenTuyen]?.htHospital}
                        searchFunction={getHospitalCategory}
                        searchObject={{
                            pageIndex: DEFAULT_PAGE_INDEX,
                            pageSize: 20,
                        }}
                        urlData="data.content"
                        labelSearch="keyword"
                        // getOptionValue={(option) => option.bvInsCode}
                        getOptionLabel={(option) => option.bvName}
                        onChange={(selectedOption) => {
                            setFieldValue(`${CODE_GENERATE_FORM.xuTriThongTinChuyenTuyen}.htHospital`, selectedOption);
                        }}
                        errors={(errors?.[CODE_GENERATE_FORM.xuTriThongTinChuyenTuyen] as any)?.htHospital}
                        touched={(touched?.[CODE_GENERATE_FORM.xuTriThongTinChuyenTuyen] as any)?.htHospital}
                        isSrcoll
                    />
                </Col>
            </Row>
        </>
    );
};

export default BenhVienChuyenTuyen;
